import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const OFFERINGS = [
  { name: "The Full Session", meta: "60 minutes — $150", note: "A private conversation with room to wander deep.", testId: "session-teaser-60" },
  { name: "The Focused Session", meta: "30 minutes — $85", note: "For one focused question that needs a clear light.", testId: "session-teaser-30" },
];

export default function Session() {
  return (
    <section id="sessions" data-testid="sessions-section" className="relative overflow-hidden bg-[#131110] py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-[#D49A36] md:text-xs"
        >
          1:1 Virtual Sessions
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="max-w-3xl font-display text-4xl font-medium leading-[1.02] tracking-tight text-[#F2EFE9] md:text-6xl"
        >
          Sit with Umi, <span className="italic text-[#D49A36]">one on one.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-[#DCD8D3] md:text-lg"
        >
          A private conversation offering space to explore the questions, patterns, transitions, and spiritual
          matters currently present in your life — intuitive and conversational, never formulaic.
        </motion.p>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {OFFERINGS.map((offering, i) => (
            <motion.div
              key={offering.testId}
              data-testid={offering.testId}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: 0.15 * i, ease: EASE }}
              className="border border-[#D49A36]/15 bg-[#1E1A18] p-8 transition-colors duration-500 hover:border-[#D49A36]/40"
            >
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#D49A36]">{offering.meta}</p>
              <h3 className="mt-3 font-display text-3xl font-medium text-[#F2EFE9]">{offering.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#DCD8D3]/80">{offering.note}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, delay: 0.35, ease: EASE }}
          className="mt-12"
        >
          <Link
            to="/sessions"
            data-testid="session-cta-button"
            className="group inline-flex items-center gap-3 bg-[#D49A36] px-8 py-4 text-xs font-bold uppercase tracking-[0.22em] text-[#131110] transition-colors duration-300 hover:bg-[#F2EFE9]"
          >
            Request a session
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
